import { BaseError } from './base/base-error';

export class ValidateError extends BaseError {
  name = 'ValidateError';
}

